import { ErrorHandler, Injectable } from '@angular/core';
import * as Sentry from '@sentry/capacitor';
import * as SentryAngular from '@sentry/angular';
import { environment } from '@environment/environment';

@Injectable({ providedIn: 'root' })
export class SentryService {

  static init() {
    if (!environment.sentryDsn) {
      return;
    }

    Sentry.init(
        {
          dsn: environment.sentryDsn,
          sendDefaultPii: true,
          release: `tarraf-imob@${ environment.appVersion }`,
          // TODO get dist from Android versionCode in build.gradle
          //  (or from Fastfile config)
          dist: '44',
          environment: environment.production ? 'production' : 'development',
          tracesSampleRate: environment.production ? 0.1 : 1.0,
        },
        SentryAngular.init,
    );
  }

  static provideSentryErrorHandler() {
    return {
      provide: ErrorHandler,
      // Attach the Sentry ErrorHandler
      useValue: SentryAngular.createErrorHandler(),
    };
  }

  captureException(error: Error) {
    Sentry.captureException(error);
  }
}
